import React, { useState } from 'react';
import { Box, Grid, TextField, Button, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BaseCodeSelectbox from '../common/form/selectbox/BaseCodeSelectbox';
import DetailTemplate from '../common/template/DetailTemplate';
import PartnerModalConatiner from '../../containers/common/form/modal/PartnerModalConatiner';
import FormLabel from '../common/form/FormLabel';

const ProjectForm = ({ formik }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const partnerAdd = () => {
    navigate(`/partnermng/add`);
  };

  const selectedPartner = (partner) => {
    formik.setFieldValue('partnerInc', partner.partnerNm);
  };

  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <DetailTemplate title="기회 확인">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              my: 2,
            }}
          >
            <Button
              type="submit"
              variant="outlined"
              disabled={formik.isSubmitting}
            >
              저장
            </Button>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              border: (theme) => `1px solid ${theme.palette.divider}`,
              bgcolor: 'background.paper',
              color: 'text.primary',
              p: 1,
            }}
          >
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>
                  매출 타입
                  <Typography
                    variant="subtitle2"
                    component="span"
                    sx={{ mx: 1, color: 'error.main' }}
                  >
                    (필수)
                  </Typography>
                </FormLabel>
              </Grid>
              <Grid item xs={9}>
                <BaseCodeSelectbox
                  formik={formik}
                  filterObject={{
                    blcCd: 'BASE',
                    mlcCd: 'FORCAST',
                    slcCd: 'PRJ_TYP',
                    useYn: 'Y',
                  }}
                  name="prjTyp"
                  size="small"
                  required={true}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>
                  고객명
                  <Typography
                    variant="subtitle2"
                    component="span"
                    sx={{ mx: 1, color: 'error.main' }}
                  >
                    (필수)
                  </Typography>
                </FormLabel>
              </Grid>
              <Grid item xs={7}>
                <TextField
                  size="small"
                  required={true}
                  variant="outlined"
                  fullWidth
                  id="partnerInc"
                  name="partnerInc"
                  value={formik.values.partnerInc}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.partnerInc &&
                    Boolean(formik.errors.partnerInc)
                  }
                  helperText={
                    formik.touched.partnerInc && formik.errors.partnerInc
                  }
                />
              </Grid>
              <Grid item xs={1}>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  onClick={handleOpen}
                >
                  고객명 선택
                </Button>
              </Grid>
              <Grid item xs={1}>
                <Button
                  component={Link}
                  color="warning"
                  variant="outlined"
                  size="small"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="/partnermng/add"
                >
                  거래처 등록
                </Button>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>산업체 구분</FormLabel>
              </Grid>
              <Grid item xs={9}>
                <BaseCodeSelectbox
                  formik={formik}
                  filterObject={{
                    blcCd: 'BASE',
                    mlcCd: 'FORCAST',
                    slcCd: 'INC_TYP',
                    useYn: 'Y',
                  }}
                  name="incTyp"
                  size="small"
                  required={false}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>
                  사업명
                  <Typography
                    variant="subtitle2"
                    component="span"
                    sx={{ mx: 1, color: 'error.main' }}
                  >
                    (필수)
                  </Typography>
                </FormLabel>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  size="small"
                  required={true}
                  variant="outlined"
                  fullWidth
                  id="cstNm"
                  name="cstNm"
                  value={formik.values.cstNm}
                  onChange={formik.handleChange}
                  error={formik.touched.cstNm && Boolean(formik.errors.cstNm)}
                  helperText={formik.touched.cstNm && formik.errors.cstNm}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>아이템 구분</FormLabel>
              </Grid>
              <Grid item xs={9}>
                <BaseCodeSelectbox
                  formik={formik}
                  filterObject={{
                    blcCd: 'BASE',
                    mlcCd: 'FORCAST',
                    slcCd: 'SOL_TYPE',
                    useYn: 'Y',
                  }}
                  name="solutionTyp"
                  size="small"
                  required={false}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>
                  예산여부
                  <Typography
                    variant="subtitle2"
                    component="span"
                    sx={{ mx: 1, color: 'error.main' }}
                  >
                    (필수)
                  </Typography>
                </FormLabel>
              </Grid>
              <Grid item xs={9}>
                <BaseCodeSelectbox
                  formik={formik}
                  filterObject={{
                    blcCd: 'BASE',
                    mlcCd: 'FORCAST',
                    slcCd: 'BUGET_YN',
                    useYn: 'Y',
                  }}
                  name="bugetYn"
                  size="small"
                  required={true}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>
                  프로젝트 중요도
                  <Typography
                    variant="subtitle2"
                    component="span"
                    sx={{ mx: 1, color: 'error.main' }}
                  >
                    (필수)
                  </Typography>
                </FormLabel>
              </Grid>
              <Grid item xs={9}>
                <BaseCodeSelectbox
                  formik={formik}
                  filterObject={{
                    blcCd: 'BASE',
                    mlcCd: 'FORCAST',
                    slcCd: 'PRJ_IMPT',
                    useYn: 'Y',
                  }}
                  name="prjImpt"
                  size="small"
                  required={true}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>
                  기회 구분
                  <Typography
                    variant="subtitle2"
                    component="span"
                    sx={{ mx: 1, color: 'error.main' }}
                  >
                    (필수)
                  </Typography>
                </FormLabel>
              </Grid>
              <Grid item xs={9}>
                <BaseCodeSelectbox
                  formik={formik}
                  filterObject={{
                    blcCd: 'BASE',
                    mlcCd: 'FORCAST',
                    slcCd: 'CHANCE_TYP',
                    useYn: 'Y',
                  }}
                  name="chanceTyp"
                  size="small"
                  required={true}
                />
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>
                  거래처 유형
                  <Typography
                    variant="subtitle2"
                    component="span"
                    sx={{ mx: 1, color: 'error.main' }}
                  >
                    (필수)
                  </Typography>
                </FormLabel>
              </Grid>
              <Grid item xs={9}>
                <BaseCodeSelectbox
                  formik={formik}
                  filterObject={{
                    blcCd: 'BASE',
                    mlcCd: 'PARTNER',
                    slcCd: 'PARTNER_TYP',
                    useYn: 'Y',
                  }}
                  name="partnerTyp"
                  size="small"
                  required={true}
                />
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>
                  고객 담당자
                  <Typography
                    variant="subtitle2"
                    component="span"
                    sx={{ mx: 1, color: 'error.main' }}
                  >
                    (필수)
                  </Typography>
                </FormLabel>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  size="small"
                  required={true}
                  variant="outlined"
                  fullWidth
                  id="chargeNm"
                  name="chargeNm"
                  value={formik.values.chargeNm}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.chargeNm && Boolean(formik.errors.chargeNm)
                  }
                  helperText={formik.touched.chargeNm && formik.errors.chargeNm}
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>고객담당자 이메일</FormLabel>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  size="small"
                  variant="outlined"
                  fullWidth
                  id="chargeEml"
                  name="chargeEml"
                  value={formik.values.chargeEml}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.chargeEml && Boolean(formik.errors.chargeEml)
                  }
                  helperText={
                    formik.touched.chargeEml && formik.errors.chargeEml
                  }
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Grid item xs={3}>
                <FormLabel>고객담당자 연락처</FormLabel>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  size="small"
                  variant="outlined"
                  fullWidth
                  id="chargeTel"
                  name="chargeTel"
                  value={formik.values.chargeTel}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.chargeTel && Boolean(formik.errors.chargeTel)
                  }
                  helperText={
                    formik.touched.chargeTel && formik.errors.chargeTel
                  }
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              sx={{ py: 1 }}
            >
              <Grid item xs={3}>
                <FormLabel>참고사항</FormLabel>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  size="small"
                  variant="outlined"
                  fullWidth
                  id="forcastTxt"
                  name="forcastTxt"
                  multiline
                  rows={5}
                  value={formik.values.forcastTxt}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.forcastTxt &&
                    Boolean(formik.errors.forcastTxt)
                  }
                  helperText={
                    formik.touched.forcastTxt && formik.errors.forcastTxt
                  }
                />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              my: 2,
            }}
          >
            <Button
              type="submit"
              variant="outlined"
              disabled={formik.isSubmitting}
            >
              저장
            </Button>
          </Box>
        </DetailTemplate>
      </Box>
      {open && (
        <PartnerModalConatiner
          link
          title="고객명 선택"
          open={open}
          handleClose={handleClose}
          selectedPartner={selectedPartner}
        />
      )}
    </div>
  );
};

export default ProjectForm;
